import {Dictionary} from 'favorlogic-utils';

export const PICKUP_LINE_DAIRY_PLAN_FORM_NAME = 'pickupLineDairyPlanForm';

export interface PickupLineDairyPlanFormValues {
    states: Dictionary<number, Dictionary<number, string>>;
}
